import { render, staticRenderFns } from "./Radar.vue?vue&type=template&id=2a28aae4&scoped=true"
import script from "./Radar.vue?vue&type=script&lang=js"
export * from "./Radar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a28aae4",
  null
  
)

export default component.exports